import { createSelector } from 'reselect';
import { IFilterCriteria } from '../Filter/filter.state.interfaces';
import { IState } from '../../state/store.state';
import { ICustomerState } from '../Customer/customer.state.interface';
import { IAuthenticationState } from '../../core/auth/authentication.state.interfaces';
import { isSuperUserSelector } from '../Customer/customer.selectors';
import { shoppingSessionIdSelector } from '../Shopping/shopping.selectors';
import {
  CartActivityTypeEnum,
  ICartItem,
  IProductSearchResultsModel,
  IUserCartActivityMdoel
} from './v2/anlytics.interfaces';

const filterCriteriaSelector = (appState: IState) => appState.filters;
const customerSelector = (state: IState) => state.customer;
const authenticationSelector = (state: IState) => state.authentication;

export const productSearchResultsModelSelector = createSelector(
  [filterCriteriaSelector, customerSelector, authenticationSelector, isSuperUserSelector, shoppingSessionIdSelector],
  (
    filterCriteria: IFilterCriteria,
    customer: ICustomerState,
    authentication: IAuthenticationState,
    isSuperUser: boolean,
    sessionId: number | undefined
  ) => {
    const productSearchResultsModel: IProductSearchResultsModel = {
      userAzureADId: isSuperUser ? customer.impersonation?.userGuid : authentication.account?.localAccountId,
      emailAddress: isSuperUser ? customer.impersonation?.emailAddress : authentication.account?.username,
      superUserAzureId: isSuperUser ? authentication.account?.localAccountId : null,
      superUserEmailAddress: isSuperUser ? authentication.account?.username : null,
      isInternalCompanyEmployee: isSuperUser,
      alloy: filterCriteria.alloy,
      finish: filterCriteria.finish,
      gauge: filterCriteria.gauge,
      length: filterCriteria.length,
      companyName: customer.customerInfo.company,
      temper: filterCriteria.temper,
      width: filterCriteria.width,
      warehouseName: filterCriteria.warehouseNames?.toString(),
      castNumber: null,
      resultCount: 0,
      sessionId: sessionId
    };

    return productSearchResultsModel;
  }
);

export const createCartActivitySelector = (cartActivityTypeId: CartActivityTypeEnum, cartItems: ICartItem[]) =>
  createSelector(
    [authenticationSelector, customerSelector, isSuperUserSelector, shoppingSessionIdSelector],
    (
      authentication: IAuthenticationState,
      customer: ICustomerState,
      isSuperUser: boolean,
      sessionId: number | undefined
    ): IUserCartActivityMdoel[] => {
      return cartItems.map((cartItem) => {
        const userCartActivityModel: IUserCartActivityMdoel = {
          userAzureADId: isSuperUser ? customer.impersonation?.userGuid : authentication.account?.localAccountId,
          emailAddress: isSuperUser ? customer.impersonation?.emailAddress : authentication.account?.username,
          superUserAzureId: isSuperUser ? authentication.account?.localAccountId : null,
          superUserEmailAddress: isSuperUser ? authentication.account?.username : null,
          isInternalCompanyEmployee: isSuperUser,
          sessionId: sessionId,
          cartActivityDate: new Date(),
          cartActivityTypeId: cartActivityTypeId,
          companyName: isSuperUser ? customer.impersonation?.company : customer.customerInfo.company,
          productIdentifier: cartItem.item_id
        };

        return userCartActivityModel;
      });
    }
  );
